/* START_MODULE_CONTRACT
 * PURPOSE: Frontend UI module: OverheadRolesSelect.
 * SCOPE: React component or page.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-PROJECTS
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * OverheadRolesSelect - Мультивыбор ролей для записи оверхеда.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-14 - FIX: не передавать slotProps в TextField — Autocomplete MUI 7 использует inputProps.ref.
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: контракт компонента и парный END_METHOD.
 * END_CHANGE_SUMMARY
 */

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

/* START_METHOD_OverheadRolesSelect */
/* START_CONTRACT: OverheadRolesSelect
 * PURPOSE: Мультивыбор ролей, к которым относится накладной расход.
 * INPUTS: { label: string, roles: ProjectRole[], value: ProjectRole[], onChange: (v)=>void, disabled: boolean }.
 * OUTPUTS: { JSX.Element - мультиселект }.
 * SIDE_EFFECTS: нет (делегирует onChange).
 * LINKS: M-FE-PROJECTS
 * END_CONTRACT: OverheadRolesSelect
 */
export default function OverheadRolesSelect({
  label,
  roles,
  value,
  onChange,
  disabled,
}) {
  return (
    <Autocomplete
      multiple
      options={roles}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      getOptionLabel={(option) => `${option.name} (${option.shortName})`}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      disabled={disabled || roles.length === 0}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          size="small"
          required
          placeholder={roles.length === 0 ? 'Сначала создайте роли в проекте' : 'Выберите роли'}
        />
      )}
      noOptionsText="Нет доступных ролей"
    />
  );
}
/* END_METHOD_OverheadRolesSelect */
